(function FitBuilderDaySort($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload(['/FitBuilders/view/'], function onload() {
			$('.fit-shore-ex').click(function _presentShoreEx(e) {
				var itinerary_id   = $(this).data('itinerary-id'),
					fit_builder_id = $(this).data('fit-builder-id'),
					$modal         = $('.modal');

				e.preventDefault();

				Adzuki.Ajax.get('/FitBuilders/excursions/' + itinerary_id + '/' + fit_builder_id)
				.then(function success(content) {
					$modal.find('.modal-title').text("Shore Excursions");
					$(".modal-dialog").addClass('modal-lg');
					$modal.find('.modal-body').html(content);

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});

			});

			$('.modal').on('click', '.fb-extra-action', function _selectUnselectExcursion() {
				var	code = $(this).data('code'),
					$obj = $(this);

				if ($('.fb-extra[data-code="' + code + '"]').hasClass('fb-extra-selected')) {
					$('.fb-extra[data-code="' + code + '"]').removeClass('fb-extra-selected'); 

					$obj.html('Select');
				} else {
					$('.fb-extra[data-code="' + code + '"]').addClass('fb-extra-selected');

					$obj.html('Deselect');
				}
			});

			$('.modal').on('click', '.fb-excursion-process', function _processExcursions(e) {
				var excursion_list = [],
					itinerary_id   = $('#fb-excursion-itinerary-id').val(),
					fit_builder_id = $('#fb-excursion-fitbuilder-id').val(),
					url;

				e.preventDefault();

				$('.fb-extra').each(function _excursions() {
					if ($(this).hasClass('fb-extra-selected')) {
						excursion_list.push($(this).data('code'));
					}
				});

				if (excursion_list.length > 0) {
					$('.fb-seg-loader').removeClass('hidden');
					
					url = '/FitBuilders/seg/' + itinerary_id + '/' + fit_builder_id + '/' + excursion_list.join(',');
					document.location = Adzuki.base_uri + url;
				} else {
					Adzuki.StatusMessage('error', 'Please select at least one excursion');
				}
			});

			$('.fb-cpmobile-toggle').click(function _cpmobileToggle() {
				var value          = $(this).data('value'),
					fit_builder_id = $(this).data('fit-builder-id');

				Adzuki.Ajax.get('/FitBuilders/toggleCpMobile/' + fit_builder_id + '/' + value)
				.then(function success(content) {
					if (value === 1) {
						$('.fb-cpmobile-toggle[data-value="1"]').addClass('btn-primary active');
						$('.fb-cpmobile-toggle[data-value="0"]').removeClass('btn-primary active');
						$('.fb-cpmobile-toggle[data-value="0"]').addClass('btn-default');
					} else {
						$('.fb-cpmobile-toggle[data-value="0"]').addClass('btn-primary active');
						$('.fb-cpmobile-toggle[data-value="1"]').removeClass('btn-primary active');
						$('.fb-cpmobile-toggle[data-value="1"]').addClass('btn-default');
					}
				});
			});

			$('.fb-lp-toggle').click(function _liveplannerToggle() {
				var value          = $(this).data('value'),
					fit_builder_id = $(this).data('fit-builder-id');

				Adzuki.Ajax.get('/FitBuilders/toggleLivePlanner/' + fit_builder_id + '/' + value)
				.then(function success(content) {
					if (value === 1) {
						$('.fb-lp-toggle[data-value="1"]').addClass('btn-primary active');
						$('.fb-lp-toggle[data-value="0"]').removeClass('btn-primary active');
						$('.fb-lp-toggle[data-value="0"]').addClass('btn-default');
					} else {
						$('.fb-lp-toggle[data-value="0"]').addClass('btn-primary active');
						$('.fb-lp-toggle[data-value="1"]').removeClass('btn-primary active');
						$('.fb-lp-toggle[data-value="1"]').addClass('btn-default');
					}
				});
			});

			$('.fb-map-toggle').click(function _mapToggle() {
				var value          = $(this).data('value'),
					fit_builder_id = $(this).data('fit-builder-id');

				Adzuki.Ajax.get('/FitBuilders/toggleMap/' + fit_builder_id + '/' + value)
				.then(function success(content) {
					if (value === 1) {
						$('.fb-map-toggle[data-value="1"]').addClass('btn-primary active');
						$('.fb-map-toggle[data-value="0"]').removeClass('btn-primary active');
						$('.fb-map-toggle[data-value="0"]').addClass('btn-default');
					} else {
						$('.fb-map-toggle[data-value="0"]').addClass('btn-primary active');
						$('.fb-map-toggle[data-value="1"]').removeClass('btn-primary active');
						$('.fb-map-toggle[data-value="1"]').addClass('btn-default');
					}
				});
			});

			$('.fb-published-toggle').click(function _mapToggle() {
				var value          = $(this).data('value'),
					fit_builder_id = $(this).data('fit-builder-id');

				Adzuki.Ajax.get('/FitBuilders/togglePublished/' + fit_builder_id + '/' + value)
				.then(function success(content) {
					if (value === 1) {
						$('.fb-published-toggle[data-value="1"]').addClass('btn-primary active');
						$('.fb-published-toggle[data-value="0"]').removeClass('btn-primary active');
						$('.fb-published-toggle[data-value="0"]').addClass('btn-default');
					} else {
						$('.fb-published-toggle[data-value="0"]').addClass('btn-primary active');
						$('.fb-published-toggle[data-value="1"]').removeClass('btn-primary active');
						$('.fb-published-toggle[data-value="1"]').addClass('btn-default');
					}
				});
			});

			$('.fb-copy-to-clipboard').click(function _copyToClipboard(e) {
				var $temp = $("<input>"),
					url   = $(this).data('url');

				e.preventDefault();
				$("body").append($temp);

				$temp.val(url).select();
				document.execCommand("copy");
				$temp.remove();

				Adzuki.StatusMessage(null, 'Copied to clipboard', 'Copied to clipboard');
			});

			$('#sidebar-right-content').on('click', '.result-special-sale-details', function showSpecialSaleDetails(e) {
				var special_sale_id = $(this).data("special-sale-id"),
					$modal          = $(".modal");

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-body').text('Loading Special Sale Details...');

				Adzuki.Ajax.get('/Offers/detail/' + special_sale_id)
				.then(function success(html) {
					$modal.find('.modal-body').html(html);
					$modal.find('[data-toggle^="tooltip"]').tooltip();
				});

				$modal.find('.modal-title').text('Special Sale Details');
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		});
	});
}(jQuery, window.Adzuki || {}));